export default [
    {
        path: '/activities/mgm',
        name: 'mgm',
        meta: {
            title: '邀请好友',
            auth: true,
            track: {
                evt: 'RECOMMEND_HOME',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/activities/mgm/index.vue')), 'mgm')
    },
    {
        path: '/activities/mgm/record',
        name: 'mgm-record',
        meta: {
            title: '邀请记录',
            auth: true,
            track: {
                evt: 'RECOMMEND_RECORD',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm/record.vue')),
                'mgm-record'
            )
    },
    {
        path: '/activities/mgm/recommend',
        name: 'mgm-recommend',
        meta: {
            title: '推荐有礼',
            auth: true,
            track: {
                evt: 'RECOMMEND_HOME',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm/recommend.vue')),
                'mgm-recommend'
            )
    },
    {
        path: '/activities/mgm/register',
        name: 'mgm-register',
        meta: {
            title: '万达普惠合伙人',
            auth: false,
            track: {
                evt: 'RECOMMEND_HOME',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm/register.vue')),
                'mgm-register'
            )
    },
    {
        path: '/activities/mgm/rules',
        name: 'mgm-rules',
        meta: {
            title: '活动规则',
            auth: true,
            track: {
                evt: 'RECOMMEND_RULE',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm201805/rules.vue')),
                'mgm-rules'
            )
    },
    {
        path: '/activities/mgm/201805',
        name: 'mgm-201805',
        meta: {
            title: '推荐有礼',
            auth: true,
            track: {
                evt: 'RECOMMEND_HOME',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm201805/index.vue')),
                'mgm-201805'
            )
    },
    {
        path: '/activities/mgm/201805/record',
        name: 'mgm-record-201805',
        meta: {
            title: '邀请记录',
            auth: true,
            track: {
                evt: 'RECOMMEND_RECORD',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm201805/record.vue')),
                'mgm-record-201805'
            )
    },
    {
        path: '/activities/mgm/201805/recommend',
        name: 'mgm-recommend-201805',
        meta: {
            title: '推荐有礼',
            auth: true,
            track: {
                evt: 'RECOMMEND_HOME',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm201805/recommend.vue')),
                'mgm-recommend-201805'
            )
    },
    {
        path: '/activities/mgm/201805/rules',
        name: 'mgm-rules-201805',
        meta: {
            title: '活动规则',
            auth: true,
            track: {
                evt: 'RECOMMEND_RULE',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/mgm201805/rules.vue')),
                'mgm-rules-201805'
            )
    },
    {
        path: '/activities/assistant/register',
        name: 'assistant-register',
        meta: {
            title: '店员贷',
            auth: false,
            track: {
                evt: 'RECOMMEND_HOME',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/assistant/register.vue')),
                'assistant-register'
            )
    },
    {
        path: '/activities/panda/index',
        name: 'panda-index',
        meta: {
            title: '熊猫活动',
            auth: false,
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/panda/index.vue')),
                'panda-index'
            )
    },
    {
        path: '/activities/panda/result',
        name: 'panda-index',
        meta: {
            title: '熊猫活动',
            auth: false,
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/panda/result.vue')),
                'panda-index'
            )
    },
    {
        path: '/activities/panda/search',
        name: 'panda-search',
        meta: {
            title: '熊主客户查询管理',
            auth: false,
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/panda/search.vue')),
                'panda-search'
            )
    },
    {
        path: '/activities/pre-regist/ffd',
        name: 'ffd-pre-regist',
        meta: {
            title: '飞凡贷来了!',
            track: {
                evt: 'FFD_PRE_REGIST',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/ffd.vue')),
                'ffd-pre-regist'
            )
    },
    {
        path: '/activities/pre-regist/wdd',
        name: 'wdd-pre-regist',
        meta: {
            title: '注册万达普惠',
            track: {
                evt: 'FFD_PRE_REGIST',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd.vue')),
                'wdd-pre-regist'
            )
    },
    {
        path: '/activities/pre-regist/wdd201805',
        name: 'wdd-pre-regist-201805',
        meta: {
            title: '注册万达普惠',
            track: {
                evt: 'FFD_PRE_REGIST',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd201805.vue')),
                'wdd-pre-regist-201805'
            )
    },
    {
        path: '/activities/anniversary/wdd',
        name: 'wdd-anniversary-wdd',
        meta: {
            title: '普惠日-万达普惠',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/anniversary/wdd.vue')),
                'wdd-anniversary-wdd'
            )
    },
    {
        path: '/activities/pre-regist/wdd-20190701',
        name: 'wdd-pre-regist-20190701',
        meta: {
            title: '注册万达普惠',
            track: {
                evt: 'FFD_PRE_REGIST',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd-20190701.vue')),
                'wdd-pre-regist-20190701'
            )
    },
    {
        path: '/activities/pre-regist/wdd-20190702',
        name: 'wdd-pre-regist-20190702',
        meta: {
            title: '注册万达普惠',
            track: {
                evt: 'FFD_PRE_REGIST',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd-20190702.vue')),
                'wdd-pre-regist-20190702'
            )
    },
    {
        path: '/activities/pre-regist/wdd-20190703',
        name: 'wdd-pre-regist-20190703',
        meta: {
            title: '注册万达普惠',
            track: {
                evt: 'FFD_PRE_REGIST',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd-20190703.vue')),
                'wdd-pre-regist-20190703'
            )
    },
    {
        path: '/activities/pre-regist/wdd-20220601',
        name: 'wdd-pre-regist-20220601',
        meta: {
            title: '注册万达普惠',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd-20220601.vue')),
                'wdd-pre-regist-20220601'
            )
    },
    {
        path: '/activities/wandaidai-landing',
        name: 'wandaidai-landing',
        meta: {
            title: '万达贷',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wandaidai-landing.vue')),
                'wandaidai-landing'
            )
    },
    {
        path: '/activities/wandaidai-download',
        name: 'wandaidai-download',
        meta: {
            title: '注册成功',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wandaidai-download.vue')),
                'wandaidai-download'
            )
    },
    {
        path: '/activities/wandaidai-retention',
        name: 'wandaidai-retention',
        meta: {
            title: '万达贷',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wandaidai-retention.vue')),
                'wandaidai-retention'
            )
    },
    {
        path: '/activities/wandaidai-service',
        name: 'wandaidai-service',
        meta: {
            title: '咨询客服',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wandaidai-service.vue')),
                'wandaidai-service'
            )
    },
    {
        path: '/activities/anniversary/kyh',
        name: 'wdd-anniversary-kyh',
        meta: {
            title: '普惠日-快易花',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/anniversary/kyh.vue')),
                'wdd-anniversary-kyh'
            )
    },
    {
        path: '/activities/ad/201908/pg1501',
        name: 'ad2019081501',
        meta: {
            title: '借款享双重优惠',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019081501',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201908/pg1501.vue')),
                'ad2019081501'
            )
    },

    {
        path: '/activities/ad/201908/pg1502',
        name: 'ad2019081502',
        meta: {
            title: '借款享双重优惠',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019081502',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201908/pg1502.vue')),
                'ad2019081502'
            )
    },
    {
        path: '/activities/ad/201908/pg1503',
        name: 'ad2019081503',
        meta: {
            title: '借款享双重优惠',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019081503',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201908/pg1503.vue')),
                'ad2019081503'
            )
    },
    {
        path: '/activities/ad/201909/pg1601',
        name: 'ad2019091601',
        meta: {
            title: '万达普惠9月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019091601',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201909/pg1601.vue')),
                'ad2019091601'
            )
    },
    {
        path: '/activities/ad/201909/pg1602',
        name: 'ad2019091602',
        meta: {
            title: '万达普惠9月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019091602',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201909/pg1602.vue')),
                'ad2019091602'
            )
    },
    {
        path: '/activities/ad/201909/pg1603',
        name: 'ad2019091603',
        meta: {
            title: '万达普惠9月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019091603',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201909/pg1603.vue')),
                'ad2019091603'
            )
    },
    {
        path: '/activities/ad/201909/pg1604',
        name: 'ad2019091604',
        meta: {
            title: '万达普惠9月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019091604',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201909/pg1604.vue')),
                'ad2019091604'
            )
    },
    {
        path: '/activities/ad/201910/pg2201',
        name: 'ad2019102201',
        meta: {
            title: '万达普惠10月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019102201',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201910/pg2201.vue')),
                'ad2019102201'
            )
    },
    {
        path: '/activities/ad/201910/pg2202',
        name: 'ad2019102202',
        meta: {
            title: '万达普惠10月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019102202',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201910/pg2202.vue')),
                'ad2019102202'
            )
    },
    {
        path: '/activities/ad/201910/pg2203',
        name: 'ad2019102203',
        meta: {
            title: '万达普惠10月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019102203',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201910/pg2203.vue')),
                'ad2019102203'
            )
    },
    {
        path: '/activities/ad/201910/pg2204',
        name: 'ad2019102204',
        meta: {
            title: '万达普惠10月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019102204',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201911/pg2204.vue')),
                'ad2019112204'
            )
    },
    {
        path: '/activities/ad/201911/pg2201',
        name: 'ad2019112201',
        meta: {
            title: '万达普惠11月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019112201',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201911/pg2201.vue')),
                'ad2019112201'
            )
    },
    {
        path: '/activities/ad/201911/pg2202',
        name: 'ad2019112202',
        meta: {
            title: '万达普惠11月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019112202',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201911/pg2202.vue')),
                'ad2019112202'
            )
    },
    {
        path: '/activities/ad/201911/pg2203',
        name: 'ad2019112203',
        meta: {
            title: '万达普惠11月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019112203',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201911/pg2203.vue')),
                'ad2019112203'
            )
    },
    {
        path: '/activities/ad/201911/pg2204',
        name: 'ad2019112204',
        meta: {
            title: '万达普惠11月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2019112204',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/201911/pg2204.vue')),
                'ad2019112204'
            )
    },
    {
        path: '/activities/ad/202003/pg2003',
        name: 'ad2020031001',
        meta: {
            title: '万达普惠3月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020031001',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202003/pg2003.vue')),
                'ad2020031001'
            )
    },
    {
        path: '/activities/ad/202003/pg2004',
        name: 'ad2020031002',
        meta: {
            title: '防骗提示',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020031002',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202003/pg2004.vue')),
                'ad2020031002'
            )
    },
    {
        path: '/activities/ad/202003/pg2005',
        name: 'ad2020031003',
        meta: {
            title: '万达普惠3月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020031003',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202003/pg2005.vue')),
                'ad2020031003'
            )
    },
    {
        path: '/activities/ad/202003/pg2006',
        name: 'ad2020031004',
        meta: {
            title: '万达普惠3月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020031004',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202003/pg2006.vue')),
                'ad2020031004'
            )
    },
    {
        path: '/activities/ad/202004/pg2001',
        name: 'ad2020041001',
        meta: {
            title: '限制消费人员情况',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020041001',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202004/pg2001.vue')),
                'ad2020041001'
            )
    },
    {
        path: '/activities/ad/202004/kyhpg2001',
        name: 'kyhad2020041001',
        meta: {
            title: '限制消费人员情况',
            track: {
                evt: 'BRAND_ACTIVITIES_KYH_AD_2020041001',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202004/kyhpg2001.vue')),
                'kyhad2020041001'
            )
    },
    {
        path: '/activities/ad/202004/pg2002',
        name: 'ad2020041002',
        meta: {
            title: '万达普惠4月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020041002',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202004/pg2002.vue')),
                'ad2020041002'
            )
    },
    {
        path: '/activities/ad/202004/pg2003',
        name: 'ad2020041003',
        meta: {
            title: '万达普惠4月福利',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020041003',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202004/pg2003.vue')),
                'ad2020041003'
            )
    },
    {
        path: '/activities/ad/202004/pg2004',
        name: 'ad2020041004',
        meta: {
            title: '执行快讯',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020041004',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202004/pg2004.vue')),
                'ad2020041004'
            )
    },
    {
        path: '/activities/ad/202005/pg0501',
        name: 'ad2020050501',
        meta: {
            title: '执行快讯',
            track: {
                evt: 'BRAND_ACTIVITIES_AD_2020050501',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/202005/pg0501.vue')),
                'ad2020050501'
            )
    },
    {
        path: '/activities/ad/active',
        name: 'adActive',
        meta: {
            title: '万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/active.vue')),
                'adActive'
            )
    },
    {
        path: '/activities/ad/raise',
        name: 'adRaise',
        meta: {
            title: '马上提额'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/raise.vue')),
                'adRaise'
            )
    },
    {
        path: '/activities/pre-regist/shd',
        name: 'shd-anniversary-shd',
        meta: {
            title: '商户贷',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/shd.vue')),
                'shd-pre-regist/shd'
            )
    },
    {
        path: '/activities/pre-regist/shd-20210531',
        name: 'shd-anniversary-shd-20210531',
        meta: {
            title: '商户贷',
            track: {
                evt: '',
                label: ''
            }
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/shd-20210531.vue')),
                'shd-pre-regist/shd-20210531'
            )
    },
    {
        path: '/activities/active',
        name: 'active',
        meta: {
            title: '万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/ad/active.vue')),
                'active'
            )
    },
    {
        path: '/activities/kyh',
        name: 'adKyh',
        meta: {
            title: '快易花'
        },
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/activities/ad/kyh.vue')), 'adKyh')
    },
    {
        path: '/activities/pre-regist/wandan',
        name: 'wandan',
        meta: {
            title: '万单贷'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wandan.vue')),
                'wsd'
            )
    },
    {
        path: '/activities/pre-regist/wsd',
        name: 'wsd',
        meta: {
            title: '万商贷'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wsd.vue')),
                'wsd'
            )
    },
    {
        path: '/activities/pre-regist/wsd-fl',
        name: 'wsd-fl',
        meta: {
            title: '万商贷'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wsd-fl.vue')),
                'wsd-fl'
            )
    },
    {
        path: '/activities/pre-regist/wd-pe-questionnaire/register',
        name: 'PE-register',
        meta: {
            title: '体育问卷调查'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () =>
                    resolve(
                        require('../pages/activities/pre-regist/wd-pe-questionnaire/register.vue')
                    ),
                'PE-register'
            )
    },
    {
        path: '/activities/pre-regist/wd-pe-questionnaire/result',
        name: 'PE-result',
        meta: {
            title: '体育问卷调查'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () =>
                    resolve(
                        require('../pages/activities/pre-regist/wd-pe-questionnaire/result.vue')
                    ),
                'PE-result'
            )
    },
    {
        path: '/activities/pre-regist/wd-pe-questionnaire/questionnaire',
        name: 'PE-questionnaire',
        meta: {
            title: '体育问卷调查'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () =>
                    resolve(
                        require('../pages/activities/pre-regist/wd-pe-questionnaire/questionnaire.vue')
                    ),
                'PE-questionnaire'
            )
    },
    {
        path: '/activities/pre-regist/wdd-gdyh',
        name: 'PE-gdyh',
        meta: {
            title: '万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd-gdyh/index.vue')),
                'PE-gdyh'
            )
    },
    {
        path: '/activities/wallet/envelope',
        name: 'PE-envelope',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wallet/envelope.vue')),
                'PE-envelope'
            )
    },
    {
        path: '/activities/wallet/home',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wallet/home.vue')),
                'PE-home'
            )
    },
    {
        path: '/activities/wallet/coupon',
        name: 'PE-coupon',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wallet/coupon.vue')),
                'PE-coupon'
            )
    },
    {
        path: '/activities/wallet/introduce',
        name: 'PE-introduce',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wallet/introduce.vue')),
                'PE-introduce'
            )
    },
    {
        path: '/activities/wdd/sms',
        name: 'PE-sms',
        meta: {
            title: '万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wdd/sms.vue')),
                'PE-sms'
            )
    },
    {
        path: '/activities/wallet/sms-activity',
        name: 'PE-sms',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wallet/sms-activity.vue')),
                'PE-sms-activity'
            )
    },
    {
        path: '/activities/wallet/sms',
        name: 'PE-sms',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/wallet/sms.vue')),
                'PE-sms'
            )
    },
    {
        path: '/activities/wallet/wallet-page/home',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/home.vue'))
            )
    },
    {
        path: '/activities/wallet/wallet-page/red-packet',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/red-packet.vue'))
            )
    },
    {
        path: '/activities/wallet/wallet-page/discount',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/discount.vue'))
            )
    },
    {
        path: '/activities/wallet/wallet-page/introduce',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/introduce.vue'))
            )
    },
    {
        path: '/activities/wallet/wallet-page/envelope',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/envelope.vue'))
            )
    },
    {
        path: '/activities/wallet/wallet-page/couponone',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/couponone.vue'))
            )
    },
    {
        path: '/activities/wallet/wallet-page/coupontwo',
        name: 'PE-home',
        meta: {
            title: '万达钱包'
        },
        component: (resolve) =>
            require.ensure([], () =>
                resolve(require('../pages/activities/wallet/wallet-page/coupontwo.vue'))
            )
    },
    {
        path: '/activities/pre-regist/wdd-wdqb',
        name: '/wdd-wdqb',
        meta: {
            title: '注册万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/wdd-wdqb.vue')),
                '/wdd-wdqb'
            )
    },
    {
        path: '/activities/pre-regist/byj-wdqb',
        name: '/byj-wdqb',
        meta: {
            title: '备用金'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/byj-wdqb.vue')),
                '/byj-wdqb'
            )
    },
    {
        path: '/activities/pre-regist/byj-agreement',
        name: '/byj-agreement',
        meta: {
            title: '协议'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/pre-regist/byj-agreement.vue')),
                '/byj-agreement'
            )
    },
    {
        path: '/activities/down',
        name: '/wdd-down',
        meta: {
            title: '下载-万达普惠'
        },
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/activities/down.vue')), '/wdd-down')
    },
    {
        path: '/activities/copydown',
        name: '/wdd-copydown',
        meta: {
            title: '下载-万达普惠'
        },
        component: (resolve) =>
            require.ensure(
                [],
                () => resolve(require('../pages/activities/copydown.vue')),
                '/wdd-copydown'
            )
    },
    {
        path: '/activities/pre-regist/member',
        name: '/wdd-member',
        meta: {
            title: ''
        },
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/activities/pre-regist/member.vue')), '/wdd-member')
    },
    {
        path: '/activities/pre-regist/wdd-outside',
        name: '/wdd-outside',
        meta: {
            title: ''
        },
        component: (resolve) =>
            require.ensure([], () => resolve(require('../pages/activities/pre-regist/wdd-outside/index.vue')), '/wdd-outside')
    },
]



// WEBPACK FOOTER //
// ./src/routes/activities.js